let API_BASE_URL = '';
let SOCKET_URL = '';
/*let env = process.env.UMI_ENV;
if (env === 'local') {
  API_BASE_URL = 'http://localhost:8095/im';
  SOCKET_URL = 'ws://' + window.location.hostname + ':' + '34567';
  // API_BASE_URL = 'https://test.connectnowai.com/im';
  // SOCKET_URL = 'wss://' + 'test.connectnowai.com/websocket/';
} else if (env === 'development') {
  API_BASE_URL = 'https://test.connectnowai.com/im';
  SOCKET_URL = 'wss://' + 'test.connectnowai.com/websocket/';
} else if (env === 'production') {
  API_BASE_URL = 'https://www.connectnowai.com/im';
  SOCKET_URL = 'wss://' + 'www.connectnowai.com/websocket/';
}*/
API_BASE_URL = 'https://' + process.env.API_HOST + '/im';
SOCKET_URL = 'wss://' + process.env.API_HOST + '/websocket/';
const constants = {
  KEY_CLIENT_USER_INPUT: 'client_system_event', //用户输入
  MESSAGE_WITHDRAW: 'message_withdraw', //撤回
  BE_INPUTING: 'be_inputting', //正在输入
  KEY_CLIENT_CHANGE_STATUS: 'client_change_status', //修改用户状态
  API_HOST: API_BASE_URL,
  CIM_HOST: window.location.hostname,
  CIM_PORT: 34567,
  CIM_URI: SOCKET_URL,
  APP_VERSION: '1.0.0',
  APP_CHANNEL: 'web',
  APP_PACKAGE: 'com.connectnow.im',
  ACTION_999: '999',
  DATA_HEADER_LENGTH: 1,
  MESSAGE: 2,
  REPLY_BODY: 4,
  SENT_BODY: 3,
  PING: 1,
  PONG: 0,
  KEY_HANDSHAKE: 'client_handshake',
  CODE_UNAUTHORIZED: '401',
  CODE_OK: '200',
  CODE_ERROR: '500',
  KEY_CLIENT_BIND: 'client_bind',
  KEY_CLIENT_CLOSED: 'client_closed',
  PONG_BODY: new Uint8Array([80, 79, 78, 71]),
  KEY_CLIENT_CLOSED_ACW: 'client_closed_acw',
  MAX_RECONNECT_COUNT: 2,
  KEY_CLIENT_CALL: 'client_call',
  KEY_CLIENT_MESSAGE_READ: 'client_message_read',
  KEY_CLIENT_SYSTEM_EVENT: 'client_system_event',
  KEY_CLIENT_REASSIGN: 'client_reassign',
  CLIENT_NO_AVAILABLE_AGENT: 'client_no_available_agent',
  role: 'customer', // customer 客户，agent 坐席

  sessionAction: {
    action_1000: '1000', // 绑定连接成功
    action_1001: '1001', // 连接会话已存在
    action_1002: '1002', // 通话未接听时断开成功
    action_1003: '1003', // 通话已断开时再次断开，客户端执行关闭会话
    action_1004: '1004', // 下线
    action_1005: '1005', // 通话断开，客户端开启会话ACW状态
    action_1006: '1006', // 通话结束，客户端执行关闭会话
    action_5001: '5001', // 异常
  },
};

export default constants;
